import Header from "../components/header";
import LeadDetail from "../components/LeadDetails";
import Sidebar from "../components/sidebar";
import { UserPlus,UserCheck } from "lucide-react";


const LeadDetailsPage = () => {
  return (
    <div>
        <Header 
        title="Opportunity"
            icon={<UserPlus className="w-5 h-5" />}/>
        <Sidebar />
      <LeadDetail />
    </div>
  );
};
export default LeadDetailsPage;